<template>
  <span style="display: inline-block; min-width: 48px;">
    <template v-if="loading">
      <v-progress-circular
        indeterminate
        color="primary"
        size="18"
        width="1"
      ></v-progress-circular>
    </template>
    <template v-else-if="linkable && !readonly">
      <span
        v-if="numeroOrdine"
        class="blue--text text-decoration-underline"
        :style="loadingDettaglio ? 'cursor: wait' : 'cursor: pointer'"
        @click="apriDettaglio"
      >
        <v-progress-circular
          v-if="loadingDettaglio"
          indeterminate
          size="12"
          width="1"
          color="blue"
        />
        <span v-else># {{ numeroOrdine }}<span v-if="subNumero"> / {{ subNumero }}</span></span>
      </span>
      <OrdineDettaglio
        v-if="ordineCompleto"
        ref="ordineDialog"
        :ordine="ordineCompleto"
        noIcon
      ></OrdineDettaglio>
    </template>
    <template v-else-if="linkable && readonly">
      <span v-if="numeroOrdine" class="blue--text text-decoration-underline"
        ># {{ numeroOrdine }}</span
      >
    </template>
    <template v-else>
      <span class="grey--text"># {{ id_ordine }}</span>
    </template>
  </span>
</template>

<script>
import OrdineDettaglio from "../../Ordini/desktop/ordine_dettaglio/ordine_dettaglio_dialog.vue";

export default {
  components: {
    OrdineDettaglio,
  },
  props: {
    id_ordine: {
      required: true,
    },
    id_subconteggio: {
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      linkable: true,
      loading: true,
      loadingDettaglio: false,
      ordineCompleto: null,
    };
  },
  mounted() {
    this.loadNumero();
  },
  computed: {
    numeroOrdine() {
      const cached = this.$store.getters.get_ordine_numero_by_id(this.id_ordine);
      return cached ? cached.numero : null;
    },
    subNumero() {
      if (!this.id_subconteggio) return null;
      const cached = this.$store.getters.get_ordine_numero_by_id(this.id_ordine);
      if (!cached || !cached.sub_numeri) return null;
      return cached.sub_numeri[this.id_subconteggio] || null;
    },
  },
  methods: {
    loadNumero() {
      if (!this.id_ordine) {
        this.loading = false;
        return;
      }
      this.$store
        .dispatch("fetch_ordine_numero", this.id_ordine)
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.linkable = false;
        });
    },
    apriDettaglio() {
      if (this.loadingDettaglio) return;
      if (this.ordineCompleto) {
        this.$refs.ordineDialog.open();
        return;
      }
      this.loadingDettaglio = true;
      this.$store
        .dispatch("fetch_ordine_by_id", this.id_ordine)
        .then((ordine) => {
          this.ordineCompleto = ordine;
          this.loadingDettaglio = false;
          this.$nextTick(() => {
            this.$refs.ordineDialog.open();
          });
        })
        .catch(() => {
          this.loadingDettaglio = false;
        });
    },
  },
};
</script>